import React from "react";
import { NotificationManager } from "react-notifications";
import { ProduccionV2Api } from "../../../api/ProduccionV2Api";
import { DecisionSwal } from "../../../../../Utils/Utils/DecisionSwal";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import "./BadgeReabrirPaletizacion.css";

// Badge de "Paletización cerrada" que al pasarle el cursor se ofrece como botón
// para reabrirla. Va en el lugar que ya ocupaba el badge, así que no agrega
// controles nuevos a la pantalla. Reabrir solo se puede mientras el turno siga
// activo, y de eso se encarga el endpoint
export const BadgeReabrirPaletizacion = ({ onReabierta }) => {
    const { reabrirPaletizacion, cargando } = ProduccionV2Api();

    const ReabrirPaletizacion = async () => {
        try {
            await reabrirPaletizacion();

            NotificationManager.success(
                "Paletización reabierta correctamente",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al reabrir la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        } finally {
            if (onReabierta) onReabierta();
        }
    };

    const MostrarMensajeReapertura = () => {
        let mensaje = "¿Está seguro de reabrir la paletización?";
        mensaje +=
            "\n\nPodrá volver a reportar producción y enviar pallets a bodega, y el turno no podrá cerrarse hasta cerrarla de nuevo.";

        DecisionSwal(mensaje, "Sí", "No", () => ReabrirPaletizacion());
    };

    // los dos textos van montados uno sobre otro para que el ancho no salte al
    // cambiar de uno a otro
    return (
        <button
            type="button"
            className="new-badge new-badge-success badge-reabrir"
            onClick={MostrarMensajeReapertura}
            disabled={cargando}
        >
            <span className="badge-reabrir__cerrada">Paletización cerrada</span>
            <span className="badge-reabrir__accion">Reabrir paletización</span>
        </button>
    );
};
